import { $generateNodesFromDOM } from '@lexical/html';
import { MultilineElementTransformer } from '@lexical/markdown';
import { $isTableNode, TableCellNode, TableNode, TableRowNode } from '@lexical/table';
import { LexicalEditor, LexicalNode } from 'lexical';

export const createTableTransformer = (editor: LexicalEditor): MultilineElementTransformer => ({
  type: 'multiline-element',
  dependencies: [TableNode, TableCellNode, TableRowNode],

  regExpStart: /^<table(?:\s[^>]*)?>$/i,
  regExpEnd: /^<\/table>$/i,

  export: (node: LexicalNode) => {
    if (!$isTableNode(node)) {
      return null;
    }

    const exportOutput = node.exportDOM(editor);
    if (!exportOutput?.element) {
      return null;
    }

    return (exportOutput.element as HTMLElement).outerHTML;
  },

  replace: (parentNode, children, startMatch, endMatch, linesInBetween) => {
    if (!startMatch || !endMatch || !linesInBetween) {
      return;
    }

    const tableHtml = [startMatch[0], ...linesInBetween, endMatch[0]].join('\n');
    const parser = new DOMParser();
    const doc = parser.parseFromString(tableHtml, 'text/html');
    const nodes = $generateNodesFromDOM(editor, doc);

    if (nodes.length === 0) {
      return;
    }

    nodes.forEach(node => parentNode.append(node));

    const lastNode = nodes[nodes.length - 1];
    if (lastNode) {
      lastNode.selectEnd();
    }
  },
});
